import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import useSearchParamActions from '@/customHooks/useSearchParamActions';

function ToolTypeFilter() {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  const toolTypeFilters = ['Laser', 'Endmill'];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          Tool Type
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          onClick={() => {
            removeSearchParam('toolType');
          }}
        >
          All
        </DropdownMenuItem>
        {toolTypeFilters.map((toolTypeFilter) => (
          <DropdownMenuItem
            key={toolTypeFilter}
            onClick={() => {
              appendSearchParam('toolType', toolTypeFilter);
            }}
          >
            {toolTypeFilter}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ToolTypeFilter;
